import React, { useEffect, useState } from 'react';
import MasterSpotlight from './MasterSpotlight';
import SimpleTest from './SimpleTest';
import QuickTaskSpotlight from './QuickTaskSpotlight';

interface GlobalKeyboardShortcutsProps {
  onQuickMessage?: () => void;
  onQuickTask?: () => void;
}

const GlobalKeyboardShortcuts: React.FC<GlobalKeyboardShortcutsProps> = ({ onQuickMessage, onQuickTask }) => {
  const [showMasterSpotlight, setShowMasterSpotlight] = useState(false);
  const [showSimpleTest, setShowSimpleTest] = useState(false);
  const [showQuickTask, setShowQuickTask] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+K for Master Spotlight
      if (e.ctrlKey && e.key === 'k') {
        e.preventDefault();
        setShowMasterSpotlight(true);
        
        // Force focus after state update using getElementById
        setTimeout(() => {
          const input = document.getElementById('master-spotlight-search-input') as HTMLInputElement;
          if (input) {
            input.focus();
            input.select();
          }
        }, 200);
        return;
      }

      // Only handle other shortcuts if no spotlight is open
      if (!showMasterSpotlight && !showSimpleTest && !showQuickTask) {

        // Cmd+J (Mac) or Ctrl+J (Windows/Linux) for Quick Task
        if ((e.metaKey || e.ctrlKey) && e.key === 'j') {
          e.preventDefault();
          setShowQuickTask(true);
          return;
        }

        // Cmd+T (Mac) or Ctrl+T (Windows/Linux) for Time Entry
        if ((e.metaKey || e.ctrlKey) && e.key === 't') {
          e.preventDefault();
          // Trigger time entry by clicking the button
          const timeEntryButton = document.getElementById('quick-time-entry');
          if (timeEntryButton) {
            timeEntryButton.click();
          }
        }

        // Cmd+B (Mac) or Ctrl+B (Windows/Linux) for Bug Report
        if ((e.metaKey || e.ctrlKey) && e.key === 'b') {
          e.preventDefault();
          // Trigger bug report modal by clicking the button
          const bugReportButton = document.getElementById('quick-bug-report');
          if (bugReportButton) {
            bugReportButton.click();
          }
        }
      }

      // Escape to close any open modals
      if (e.key === 'Escape') {
        setShowMasterSpotlight(false);
        setShowSimpleTest(false);
        setShowQuickTask(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showMasterSpotlight, showSimpleTest, showQuickTask, onQuickTask, onQuickMessage]);


  return (
    <>
      {/* Simple Test Component */}
      <SimpleTest
        isOpen={showSimpleTest}
        onClose={() => setShowSimpleTest(false)}
      />

      {/* Master Spotlight - Universal Search & Actions */}
      <MasterSpotlight
        isOpen={showMasterSpotlight}
        onClose={() => setShowMasterSpotlight(false)}
      />

      {/* Quick Task Spotlight - Ctrl+J / Cmd+J */}
      <QuickTaskSpotlight
        isOpen={showQuickTask}
        onClose={() => setShowQuickTask(false)}
        onTaskCreated={() => setShowQuickTask(false)}
      />
    </>
  );
};

export default GlobalKeyboardShortcuts;